 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Document No.
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryDocNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryDocNoFilterForm"
                            v-model="filtersDocNo.documentNo"
                            :label="filtersDocNoLabel.documentNo"
                            :error-messages="errors.collect('filterDocNo')"
                            data-vv-name="filterDocNo"
                            :data-vv-as="filtersDocNoLabel.documentNo"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearDocNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doDocNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="docNoHeaders"
          :items="docNoItems"
          v-bind:options.sync="paginationDocNo"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsDocNo"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.docNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignDocNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { paymentFilterMixin } from '@/mixins/accounting/payment/paymentFilterMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      paginationDocNo: {
        page: 1
      }
    }
  },
  mounted() {
    // this.doClearDocNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersDocNo.documentNo = ''
      this.$emit('close')
    },
    doClearDocNoFilters() {
      this.filtersDocNo.documentNo = null
      this.fetchPaymtDocNoData()
    },
    doDocNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryDocNoFilterForm').then((result) => {
        if (result) {
          this.paginationDocNo.page = 1
          this.fetchPaymtDocNoData()
        }
      })
    },
    assignDocNo(data) {
      this.$emit('assign-doc-no', data.docNo)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    transaction: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    }
  },
  mixins: [TableConst.default, paymentFilterMixin, commonAjaxMixin]
}
</script>
